module.exports = __webpack_public_path__ + "img/iphone6.dac28a97.png";